var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavBar'),_c('Banner'),_c('router-view'),_c('Footer'),_c('FloatContact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }